import { useEffect, useState, useCallback } from "react";
import { AnimatePresence } from "framer-motion";
import Preloader from "@/components/site/Preloader";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import Philosophy from "@/components/site/Philosophy";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import ContactDialog from "@/components/site/ContactDialog";

export default function Landing({ introDone, onIntroDone }) {
  const [showIntro, setShowIntro] = useState(!introDone);
  const [dialog, setDialog] = useState({ open: false, mode: "start" });

  useEffect(() => {
    document.body.style.overflow = introDone ? "" : "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [introDone]);

  const finishIntro = useCallback(() => {
    setShowIntro(false);
    onIntroDone();
    window.scrollTo(0, 0);
  }, [onIntroDone]);

  const openStart = () => setDialog({ open: true, mode: "start" });
  const openContact = () => setDialog({ open: true, mode: "contact" });
  const closeDialog = () => setDialog((d) => ({ ...d, open: false }));

  return (
    <main className="relative bg-[#F5F3EE]">
      <AnimatePresence>{showIntro && <Preloader onComplete={finishIntro} />}</AnimatePresence>

      <Navigation visible={introDone} onContact={openContact} />

      <Hero start={introDone} onStartProject={openStart} />
      <Philosophy />
      <FinalCTA onStartProject={openStart} />
      <Footer onContact={openContact} />

      <ContactDialog open={dialog.open} mode={dialog.mode} onClose={closeDialog} />
    </main>
  );
}
